import { Theme } from '@mui/material/styles';

export const school = (theme: Theme) => ({
    marginBottom: theme.spacing(2),
}) as const;

export const text = (theme: Theme) => ({
    marginTop: theme.spacing(2),
}) as const;
